import { Controller } from '@hotwired/stimulus'

// Keeps the volume slider and number input in sync.
export default class extends Controller {
  static targets = ['range', 'number']

  syncFromRange () {
    this.numberTarget.value = this.rangeTarget.value
  }

  syncFromNumber () {
    this.rangeTarget.value = this.numberTarget.value
  }
}
